import { useState, useMemo, ReactElement } from "react";
import cls from "classnames";
import { ReactComponent } from "logic/src/components/icons/arrowVertical.svg";
import styles from "./index.module.scss";
import { IThinkingInfo } from "logic/src/objects/chat/BaseStreamRenderV2";
import { ReactComponent as ThinkingIcon } from "logic/src/components/icons/thinking.svg";

interface IProps {
  info: IThinkingInfo;
  fold: boolean;
  toggleFold: () => void;
  stoped: boolean;
  sensitive: boolean;
}

const Thinking = ({ info, fold, toggleFold, stoped, sensitive }: IProps) => {
  const content = useMemo(() => {
    const result: ReactElement[] = [];
    let str = info.text.trimStart();
    // str = str.replace(/\n/g, " ");
    str = str.replace(
      /\[ref_(\d+)\]/g,
      (match, num) => `「引用${parseInt(num) + 1}」`,
    );

    const segmenter = new Intl.Segmenter("zh", { granularity: "word" });
    const segments = segmenter.segment(str);
    const words = [...segments].map(segment => segment.segment).filter(Boolean);
    words.forEach((word: string, index: number) => {
      result.push(
        <span className="animate-fade-in" key={"thinking" + index}>
          {word}
        </span>,
      );
    });
    return result;
  }, [info.text]);
  // const [fold, setFold] = useState<boolean>(false);
  return (
    <div className={styles.container}>
      <div
        className={cls(styles.button, sensitive && styles.disabled)}
        onClick={toggleFold}
      >
        <ThinkingIcon className={styles.thinkingIcon} />
        {info.endTime
          ? `已深度思考${info.endTime - info.startTime > 200 ? `(用时${Math.ceil((info.endTime - info.startTime) / 1000)}秒)` : ""}`
          : stoped
            ? "已深度思考"
            : `思考中...(已用时${Math.ceil((new Date().getTime() - info.startTime) / 1000)}秒)`}
        <ReactComponent
          className={cls(styles.icon, !fold && !sensitive && styles.unFold)}
        />
      </div>
      {!fold && !sensitive && <div className={styles.body}>{content}</div>}
    </div>
  );
};

export default Thinking;
